import "core-js/modules/es.function.name.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/connection.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-72362e4d"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "connect"
};
var _hoisted_2 = {
  "class": "w1200px",
  style: {
    "margin": "0 auto"
  }
};
var _hoisted_3 = {
  "class": "c-detail pb-132px"
};
var _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"c-tag mt-50px\" data-aos=\"fade-up\" data-v-72362e4d>灵活集成</div><div class=\"c-intro\" data-aos=\"fade-up\" data-aos-delay=\"200\" data-v-72362e4d> 支持全部或任一产品接入客户现有系统 </div><div class=\"c-describe\" data-aos=\"fade-up\" data-aos-delay=\"400\" data-v-72362e4d> 定制化解决方案，满足不同政务场景需求 </div><div class=\"c-system flex flex-justify-between items-center\" data-v-72362e4d><div class=\"c-system-t\" data-aos=\"fade-right\" data-v-72362e4d><div class=\"font-600 font-size-28px\" data-v-72362e4d>强大的系统对接能力</div><div class=\"eng\" data-v-72362e4d>STRONG SYSTEM DOCKING ABILITY</div></div><div class=\"flex-1 rd-23px bg-white c-system-t-r\" data-aos=\"fade-left\" data-v-72362e4d><div data-v-72362e4d><div class=\"font-size-22px font-600 color-#225eef mb-6px\" data-v-72362e4d>专业政务生态连接器</div><div data-v-72362e4d>我们提供标准化集成方案，实现与各类政务系统的无缝数据互通和业务协同</div></div><img src=\"" + _imports_0 + "\" class=\"w-110px h-auto\" data-v-72362e4d></div></div>", 4);
var _hoisted_8 = {
  "class": "w-100% flex items-center flex-justify-between mt-36px"
};
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("div", {
    "class": "c-system-t",
    "data-aos": "fade-right"
  }, [/*#__PURE__*/_createElementVNode("div", {
    "class": "font-600 font-size-28px"
  }, "广泛的系统兼容范围"), /*#__PURE__*/_createElementVNode("div", {
    "class": "eng"
  }, "BROAD SYSTEM COMPATIBILITY")])], -1);
});
var _hoisted_10 = {
  "class": "c-type flex-1 rd-23px bg-white",
  "data-aos": "fade-left"
};
var _hoisted_11 = {
  "class": "w100%"
};
var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h2", {
    "class": "font-size-22px color-#121212"
  }, "民生服务领域", -1);
});
var _hoisted_13 = {
  "class": "c-type-grid flex flex-between w-100% mt-40px"
};
var _hoisted_14 = {
  "class": "w-100px h-100px"
};
var _hoisted_15 = {
  "class": "text-center line-height-16px mt-16px"
};
var _hoisted_16 = {
  "class": "w100% mt-40px pb-20px"
};
var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h2", {
    "class": "font-size-22px color-#121212"
  }, "政府热线平台", -1);
});
var _hoisted_18 = {
  "class": "c-type-grid flex flex-between w-100% mt-40px"
};
var _hoisted_19 = {
  "class": "w-100px h-100px"
};
var _hoisted_20 = {
  "class": "text-center line-height-16px mt-16px"
};
var url = 'https://qinghuiche.oss-cn-beijing.aliyuncs.com/officialWebsite/';
export default {
  __name: 'indexConnection',
  setup: function setup(__props) {
    var systemlist = [{
      name: '医保系统',
      src: url + 'yibao.png'
    }, {
      name: '热力公司',
      src: url + 'heatcompany.png'
    }, {
      name: '燃气公司',
      src: url + 'firegas.png'
    }, {
      name: '自来水公司',
      src: url + 'autowater.png'
    }, {
      name: '公交系统',
      src: url + 'bus.png'
    }];
    var hotList = [{
      name: '12328交通服务热线',
      src: url + 'carphone.png'
    }, {
      name: '110报警服务平台',
      src: url + '110.png'
    }, {
      name: '各省市区县政务工单系统',
      src: url + 'ordersystem.png'
    }, {
      name: '各级政府服务热线系统',
      src: url + 'governserve.png'
    }];
    return function (_ctx, _cache) {
      var _directive_lazy = _resolveDirective("lazy");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("div", _hoisted_13, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(systemlist, function (value, i) {
        return _createElementVNode("div", {
          key: i
        }, [_withDirectives(_createElementVNode("img", _hoisted_14, null, 512), [[_directive_lazy, value.src]]), _createElementVNode("div", _hoisted_15, _toDisplayString(value.name), 1)]);
      }), 64))])]), _createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("div", _hoisted_18, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(hotList, function (value, i) {
        return _createElementVNode("div", {
          key: i,
          "class": "type-item"
        }, [_withDirectives(_createElementVNode("img", _hoisted_19, null, 512), [[_directive_lazy, value.src]]), _createElementVNode("div", _hoisted_20, _toDisplayString(value.name), 1)]);
      }), 64))])])])])])])]);
    };
  }
};